//UTILITIES
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

//COMPONENT
import { Card, CardContent } from "@mui/material";
import { EmailSVG } from "../../../assets/svg/SVG";

import "./AuthenticationMessages.scss"

export function EmailSent( props ) {
  let navigate = useNavigate();

  useEffect( () => {
    setTimeout( function () {
      navigate( "/login" );
    }, 5000 );
  }, [] );

  return (
    <div className="page-container">
      <Card className="authmessages-container">
        <CardContent className="content">

          <div className="icon">
            <EmailSVG size={ 50 } />
          </div>

          <div className="text">
            An email has been sent. Check your inbox.
          </div>

        </CardContent>
      </Card>
    </div>
  );
}
export default EmailSent;
